<template>
    <div>
        <label class="field_label">{{ current_champ.label }}<span class="text-red"
                v-if="current_champ.mandatory == 1">*</span></label>
        <v-select :items="items" v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
            :disabled="current_champ.disabled || is_disable"
            :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>

    </div>
</template>

<script>
export default {
    props: ["champ", "inscription", "mode", "is_disable"],
    data() {
        return {
            current_champ: {},
            items: [],
        }
    },
    watch: {
    },
    methods: {
        handle_cdf_rules() {
            const selected_courses = this.inscription.list_courses.list.filter(course => course.selected);
            for (let i = 0; i < selected_courses.length; i++) {
                const course = selected_courses[i];
                const apply_rules_cdf_lc = course?.metadatas?.rules_cdf_longe_cote == "1";
                if (apply_rules_cdf_lc) {
                    this.remove_non_licencie();
                }
                else {
                    this.add_non_licencie_if_missing();
                }
            }

        },
        remove_non_licencie() {

            for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                if (item.value == "Non licencié") {
                    this.items.splice(i, 1);
                }
            }
        },
        add_non_licencie_if_missing() {


            const items = this.items;
            let is_non_licencie_present = false;
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.value == "Non licencié") {
                    is_non_licencie_present = true;
                    return;
                }
            }
            if (!is_non_licencie_present) {
                items.push({ title: "Non licencié", value: "Non licencié" });
            }
            this.items = items;

        }

    },
    async created() {
        this.current_champ = this.champ;
        this.items = this.$itemsSelect.getSelection(this.current_champ.options);
        this.handle_cdf_rules();
    },
}
</script>

<style lang="scss" scoped></style>